import * as React from 'react';
import { useEffect, useState } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';

import WidgetSelectionModal from 'bundles/author-widget/components/widgetSelectionModal/WidgetSelectionModal';
import { useWidgetContext } from 'bundles/cml/editor/context/widgetContext';
import type { WidgetModalOptions } from 'bundles/cml/editor/types/widgetTypes';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { createWidgetMap, getWidgetList } from 'bundles/cml/editor/utils/widgetApiUtils';
import type { WidgetSummary } from 'bundles/cml/editor/utils/widgetApiUtils';
import { useCourseContext, useRouter } from 'bundles/cml/shared/hooks/context';

export type Props = {
  widgetOptions?: WidgetModalOptions;
  onClose: () => void;
};

const WidgetModal = ({ widgetOptions, onClose }: Props) => {
  const [widgets, setWidgets] = useState<WidgetSummary[]>([]);
  const showDialog = !!widgetOptions;
  const { courseContext } = useCourseContext();
  const { widgetManager } = useWidgetContext();
  const courseId = courseContext?.courseId || '';
  const router = useRouter();

  useEffect(() => {
    const fetchWidgets = async () => {
      // Prevent fetching without courseId: https://coursera.slack.com/archives/C015TU49Z71/p1670471972174819
      if (!widgetManager || !courseId || !showDialog) {
        return;
      }
      const result = await getWidgetList(courseId);
      const widgetMap = createWidgetMap(result);
      widgetManager.cache[courseId] = { ...widgetMap };
      setWidgets(result);
    };

    fetchWidgets();
  }, [widgetManager, courseId, showDialog]);

  const executeAction = useFluxibleAction();

  if (!showDialog || !widgetOptions.handleSelect) {
    return null;
  }

  return (
    <WidgetSelectionModal
      courseId={courseId}
      onCancel={onClose}
      onContinue={widgetOptions.handleSelect}
      widgets={widgets || []}
      widgetMap={widgetManager?.cache[courseId] || {}}
      branchId=""
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      itemId={router.params.itemId}
      atomId=""
      name=""
      isGradedWidget={false}
      selectedWidgetId={widgetOptions.currentId}
      isEmbeddedInCml={true}
      isWidgetListLoaded={true}
      executeAction={executeAction}
    />
  );
};

export default WidgetModal;
